import { ChartData, ChartOptions } from 'chart.js';
import { TaskData } from '../constants/types';
import { numberOfServices } from '../constants/numberOfServices';
import { originalColors } from '../constants/originalColors';

export const getPieChartData = (chartData: TaskData, clickedSegment: number | null): ChartData<'pie'> => ({
        labels: numberOfServices,
        datasets:[
            {
                label: 'Total Services',
                backgroundColor:originalColors.slice(0, numberOfServices.length),
                borderColor:"rgb(255, 255, 255)",
                data:[chartData!.task_counts['0-tasks'], chartData!.task_counts['1-tasks'],chartData!.task_counts['2-tasks']],
                borderWidth: 2,
                hoverOffset: clickedSegment !== null ? 20 : 0, 
                borderRadius: 1.5, 
            }
        ],
    });